/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1
 */

export type PortalPayloadType = typeof PortalPayloadType[keyof typeof PortalPayloadType];


export const PortalPayloadType = {
  ActionModuleNoScoreReminder: 'ActionModuleNoScoreReminder',
  ActionModuleNoFulfillmentStateReminder: 'ActionModuleNoFulfillmentStateReminder',
  ActionModuleTimeSheetApprovalNeeded: 'ActionModuleTimeSheetApprovalNeeded',
  ActionModuleTimeQuotaRequired: 'ActionModuleTimeQuotaRequired',
  ActionModuleRewardDeclined: 'ActionModuleRewardDeclined',
  AutoTranslationCompleted: 'AutoTranslationCompleted',
  PersonalDocumentsImportCompleted: 'PersonalDocumentsImportCompleted',
} as const;
